import { AwardType, Bonus } from '../types/bonus';

const DEFAULT_CELEBRATION_TYPES = [AwardType.Birthday, AwardType.Welcome, AwardType.WorkAnniversary, AwardType.NewHire];
const CELEBRATION_TYPES = [AwardType.Wellness, AwardType.Custom, ...DEFAULT_CELEBRATION_TYPES];

const isCelebration = (bonus: Bonus) => {
	if (!bonus.award_type) {
		return false;
	}

	return CELEBRATION_TYPES.includes(bonus.award_type);
};

export const isDefaultCelebration = (bonus: Bonus) => {
	if (!bonus.award_type) {
		return false;
	}

	return DEFAULT_CELEBRATION_TYPES.includes(bonus.award_type);
};

export const getBonusType = (bonus: Bonus) => {
	if (isCelebration(bonus)) {
		return 'celebration';
	}

	if (bonus.award_type) {
		return 'award';
	}

	return 'bonus';
};
